import { handleError } from './handleError'

interface SearchParam {
  name: string
  value: string
}

/**
 * It takes a URL and an array of objects with a name and value property, and returns a new URL with the query parameters set.
 *
 * @param rawUrl - The url you want to add the query parameters to.
 * @param params - Query params.
 */
export const setQueryParams = (
  rawUrl: unknown,
  params: SearchParam[],
): string => {
  if (typeof rawUrl !== 'string') {
    handleError(
      new Error(
        `setQueryParams: received url is not a string, received: ${typeof rawUrl}`,
      ),
    )

    return ''
  }

  if (!rawUrl) {
    handleError(new Error(`setQueryParams: received url is an empty string`))

    return ''
  }

  let url: string

  if (rawUrl.startsWith('//')) {
    url = `https:${rawUrl}`

    // If is a relative URL I cannot use `new URL`. I need to manually split URL and parameters and use URLSearchParams
  } else if (rawUrl.startsWith('/')) {
    const [urlWithoutParameters, queryParamsString] = rawUrl.split('?')

    const urlSearchParams = new URLSearchParams(queryParamsString)

    params.forEach(({ name, value }) => {
      urlSearchParams.set(name, value)
    })

    return `${urlWithoutParameters}?${urlSearchParams.toString()}`

    // Here it could be http or https. I cannot do anything
  } else if (rawUrl.startsWith('http')) {
    url = rawUrl
  } else {
    url = `https://${rawUrl}`
  }

  const objectUrl = new URL(url)
  const { searchParams } = objectUrl

  params.forEach(({ name, value }) => {
    searchParams.set(name, value)
  })
  objectUrl.search = searchParams.toString()

  return objectUrl.toString()
}
